module.exports = __webpack_public_path__ + "static/media/lion.fbde90ec.ogg";